import React from 'react';
import {IconButtonProps} from '@mui/material';

import Icon from 'presentation/icons';
import {StyledIconButton} from './styles';

function DotButton(iconButtonProps: IconButtonProps) {
	return <button type="button" {...iconButtonProps}></button>;
}

function PrevButton(iconButtonProps: IconButtonProps) {
	return (
		<StyledIconButton size="small" {...iconButtonProps}>
			<Icon name="arrow-left-filled" />
		</StyledIconButton>
	);
}

function NextButton(iconButtonProps: IconButtonProps) {
	return (
		<StyledIconButton size="small" {...iconButtonProps}>
			<Icon name="arrow-right-filled" />
		</StyledIconButton>
	);
}

export {DotButton, PrevButton, NextButton};
